import * as n from "./widgets.js";
var o = {
  install: function install(o) {
    Object.keys(n).forEach(function (t) {
      o.component(n[t].name, n[t]);
    });
  }
};
export { o as plugin };